<template>
  <div class="modal-overlay" v-if="album" @click.self="$emit('close')">
    <div class="modal">
      <button class="close-button" @click="$emit('close')">✖</button>
      <h3>{{ album.title }} ({{ album.year }})</h3>
      <p>
        Label: <span class="label">{{ album.label }}</span>
      </p>
      <h4>Tracklist</h4>
      <div class="tracklist-container">
        <ol>
          <li v-for="(track, index) in album.tracks" :key="index">
            {{ track }}
          </li>
        </ol>
      </div>
    </div>
  </div>
</template>

<script>
export default {
  name: 'AlbumModal',
  props: {
    album: Object,
  },
};
</script>

<style scoped>
.modal-overlay {
  position: fixed;
  top: 0;
  left: 0;
  width: 100vw;
  height: 100vh;
  background: rgba(0, 0, 0, 0.858);
  z-index: 100;
  display: flex;
  justify-content: center;
  align-items: center;
}
.modal {
  background: #111;
  color: #eee;
  padding: 2rem;
  border-radius: 20px;
  max-width: 320px;
  width: 70%;
  position: relative;
  text-align: center;
  box-shadow: 0 0 15px rgba(0, 0, 0, 0.6);
  font-size: 1rem;
}

.modal h3 {
  color: #2c3e50;
  margin-bottom: 0.5rem;
  font-weight: 900;
  font-size: 1.5rem;
}

.label {
  color: #909078;
  font-weight: 700;
}

.close-button {
  position: absolute;
  top: 0.5rem;
  right: 0.75rem;
  background: none;
  color: #fff;
  border: none;
  font-size: 1.5rem;
  cursor: pointer;
}
.modal ol {
  list-style-position: inside;
  padding: 0;
  margin: 1rem auto 0;
  text-align: left;
}
.modal ol li {
  margin: 0.3rem 0;
}

.tracklist-container {
  margin: auto;
  width: fit-content;
  font-size: 1.05rem;
}
</style>
